import { render } from "./ReusableTable.vue?vue&type=template&id=05f247dc&scoped=true"
import script from "./ReusableTable.vue?vue&type=script&lang=js"
export * from "./ReusableTable.vue?vue&type=script&lang=js"

import "./ReusableTable.vue?vue&type=style&index=0&id=05f247dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f247dc"]])

export default __exports__